import { render } from "./BCheckBox.vue?vue&type=template&id=01a114d4"
import script from "./BCheckBox.vue?vue&type=script&lang=js"
export * from "./BCheckBox.vue?vue&type=script&lang=js"
script.render = render

export default script